@let availableCount = (allFormFieldOptions() | filterAvailableFields: configurations.value : -1).length;

<div class="d-flex flex-column gap-4">
  <div class="d-flex flex-column gap-5" [formGroup]="internalForm">
    <div formArrayName="configurations" class="d-flex flex-column gap-5">
      @for (configGroup of configurations.controls; track i; let i = $index) {
        <fieldset [formGroupName]="i" class="config-container">
          <legend>{{ 'page.widgetContent.addEditDialog.formAutofillMapping' | translate }} {{ i + 1 }}</legend>
          <div class="d-flex justify-content-end pb-2">
            @if (i !== 0) {
              <button
                mat-mini-fab
                color="primary"
                type="button"
                (click)="removeConfiguration(i)"
                [matTooltip]="'button.remove' | translate"
                matTooltipPosition="left"
              >
                <mat-icon>delete</mat-icon>
              </button>
            }
          </div>
          <div class="d-flex flex-column gap-3">
            <div class="d-flex gap-5 align-items-center w-100 equal-width">
              <mat-dropdown
                [formControl]="$any(configGroup).get('formField')"
                [options]="allFormFieldOptions() | filterAvailableFields: configurations.value : i"
                [configurationInput]="formFieldsDropdownConfiguration"
                [isFormSubmitted]="isFormSubmitted()"
              ></mat-dropdown>

              <mat-dropdown
                [formControl]="$any(configGroup).get('widgetRequest')"
                [options]="widgetRequests()"
                [configurationInput]="widgetRequestsDropdownConfiguration"
                [isFormSubmitted]="isFormSubmitted()"
              ></mat-dropdown>

              <div class="field-wrapper" [class.has-error]="$any(configGroup).get('content')?.invalid">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'field.contentText' | translate }}</mat-label>
                  <input matInput [formControl]="$any(configGroup).get('content')" />
                </mat-form-field>
                <app-custom-mat-error
                  *ngIf="$any(configGroup).get('content')?.invalid"
                  [control]="$any(configGroup).get('content')"
                  [isFormSubmitted]="isFormSubmitted()"
                ></app-custom-mat-error>
              </div>
            </div>
          </div>
        </fieldset>
      }
    </div>
  </div>
  <div class="d-flex justify-content-start pt-3 pb-3">
    <button
      mat-stroked-button
      type="button"
      [disabled]="availableCount === 0 || configurations.length >= allFormFieldOptions().length"
      (click)="addConfiguration()"
    >
      <mat-icon>add</mat-icon>
      {{
        'button.addContext'
          | translate: { context: ('page.widgetContent.addEditDialog.formAutofillMapping' | translate) }
      }}
    </button>
  </div>
</div>
